// Public demo store (deploy/sites/demo): set at build time by the site's
// env file. The demo login is intentionally public; the store resets nightly.
export const DEMO_MODE = process.env.REACT_APP_DEMO_MODE === '1';
export const DEMO_LOGIN = {
  email: process.env.REACT_APP_DEMO_ADMIN_EMAIL || '',
  password: process.env.REACT_APP_DEMO_ADMIN_PASSWORD || '',
};
